'use client';

import { InternalLink } from '../../../components/Clickables/InternalLink/InternalLink';
import { ArrowRightIcon } from '../../../components/Icons/ArrowRightIcon';
import { useAnalytics } from '@domain/analytics/AnalyticsContext';
import { trackEvent } from '@domain/analytics/trackEvent';

export const ShopLandingFeatureLink = () => {
  const { currentPage } = useAnalytics();
  const onClick = (): void => {
    trackEvent({
      name: 'mykiss_cta_button_clicked',
      properties: {
        page: currentPage,
        source: 'support-email',
        type: 'read-more',
      },
    });
  };

  return (
    <InternalLink
      to="/features"
      className="font-heading text-pinktail hover:text-pinktail-shade py-6 pr-6"
      onClick={onClick}
    >
      Read more
      <div className="ml-0.5 inline-block">
        <ArrowRightIcon width={20} height={20} />
      </div>
    </InternalLink>
  );
};
